import React from "react";
import { Construction } from "lucide-react";

export function Loading() {
  return <div className="center-load" data-testid="loading"><div className="spinner" /></div>;
}

export function Empty({ icon: Icon, title, sub, children }) {
  return (
    <div className="empty" data-testid="empty-state">
      {Icon && <Icon size={40} style={{ marginBottom: 12 }} />}
      <div style={{ fontWeight: 800, fontSize: 18, color: "var(--text)" }}>{title}</div>
      {sub && <div style={{ marginTop: 6 }}>{sub}</div>}
      {children && <div style={{ marginTop: 18 }}>{children}</div>}
    </div>
  );
}

export function PageHead({ title, sub, right }) {
  return (
    <div className="ss-section-head" style={{ marginTop: 0, marginBottom: 22 }}>
      <div>
        <h1 style={{ fontSize: 30 }} data-testid="page-title">{title}</h1>
        {sub && <div className="ss-muted" style={{ marginTop: 6, fontWeight: 600 }}>{sub}</div>}
      </div>
      {right}
    </div>
  );
}

export function ComingSoon({ title, sub }) {
  return (
    <div className="fade-up">
      <PageHead title={title} sub={sub} />
      <div className="ss-card" style={{ padding: 48, textAlign: "center" }}>
        <div className="stat-ic" style={{ margin: "0 auto 16px", width: 56, height: 56 }}><Construction size={26} /></div>
        <div style={{ fontWeight: 800, fontSize: 18 }}>Available in the mobile app</div>
        <div className="ss-muted" style={{ marginTop: 8, maxWidth: 420, marginInline: "auto" }}>
          This part of the seller & shopping suite is fully built in the SouqStream mobile app.
          The desktop web experience focuses on Discover, live shows, purchases, invites and admin.
        </div>
      </div>
    </div>
  );
}

export function money(n) {
  return "$" + Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
